import { Role } from "./role";

export class UserViewModel {
  userId: string;
  hasError: boolean;
  userName: string;
  role: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
  firstLogin: boolean;
  roles: Array<Role> = [];
  roleIds: Array<string> = [];
  entraToken: string;

  constructor(user: {
    id?: string;
    mail?: string;
    firstName?: string;
    lastName?: string;
    tel?: string;
    roleIds?: Array<string>;
    entraToken?: string;
  }) {
    this.userId = user.id;
    this.firstName = user.firstName;
    this.lastName = user.lastName;
    this.email = user.mail;
    this.phoneNumber = user.tel;
    this.roleIds = user.roleIds;
    this.entraToken = user.entraToken;
  }
}
